import opening from './opening';
import imageNotSave from './imageNotSave';
import headerMenu from './headerMenu';
import hashScroll from './hashScroll';
import headerScroll from './headerScroll';
import cookieAgree from './cookieAgree';
import generateGoogleMapsUrl from './generateGoogleMapsUrl';
import slider from './slider';
import localNav from './localNav';
import tab from './tab';
import tab01 from './tab01';
import inview from './inview';
import guidesPagination from './guidesPagination';
import clickMap from './clickMap';
import tagSort from './tagSort';
import guideSort from './guideSort';
import modalMovie from './modalMovie';

opening();
imageNotSave();
hashScroll();
objectFitImages();

if (document.getElementsByClassName('js-hamburger').length > 0) {
  headerMenu();
}

if (document.getElementById('js-cookie') !== null) {
  cookieAgree();
}

if (document.getElementsByClassName('js-generateGoogleMapsUrl').length > 0) {
  generateGoogleMapsUrl();
}

if (document.getElementById('js-tagSort') !== null) {
  tagSort();
}

if (document.getElementById('js-guideSort') !== null) {
  guideSort();
}

headerScroll();
slider();
localNav();
tab();
tab01();
inview();
guidesPagination();
clickMap();
modalMovie();
